import { useState } from "react";
import Footer from "../components/Footer";
import "../styles/ProgrammeCqp.css";
import { Link } from "react-router-dom";

export default function ProgrammeCqp() {
  const [activeTab, setActiveTab] = useState("programme");
  return (
    <>
      <div className="programme-cqp">

        <div className="progcqp-hero">
          <img src="/Assets/cqp-prog.jpg" alt="programme CQP" />

          <div className="progcqp-content">
            <h1 className="programmecqp-title">
                CQPIF <br/>(CERTIFICAT DE QUALIFICATION <br/>PROFESIONELLE INSTRUCTEUR FITNESS)
            </h1>

          <div className="cqp-buttons">
              <Link to="/inscription" className="btn-primary">
                INSCRIPTION
              </Link>

              
              <a href="/Assets/docs/Programme_CQP_à_telecharger.pdf"
                download
                className="btn-secondary"
              >
                TÉLÉCHARGER LE DOSSIER
              </a>

              <a
                href="/Assets/docs/CERTIFICAT-MEDICAL.pdf"
                download
                className="btn-secondary"
              >
                CERTIFICAT MÉDICAL
              </a>
            </div>
          </div>

        </div>

<div className="programme-cqp-cards__container">
  <div className="programme-cqp-cards__tabs">
    <button
        className={activeTab === "programme" ? "active" : ""}
        onClick={() => setActiveTab("programme")}
    >
        Les 8 modules
    </button>

    <button
        className={activeTab === "date" ? "active" : ""}
        onClick={() => setActiveTab("date")}
    >
        Date
    </button>
  </div>

  <div className="programme-cqp-cards__content">

    {activeTab === "programme" && (
      <>
        <div className="programme-cqp-cards__module">
          <h3>M1 - Nutrition appliquée au coaching</h3>
          <p>Bases des macronutriments, timing nutritionnel, cadre légal, réponses aux questions fréquentes des clients</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M2 - Coacher les publics spécifiques</h3>
          <p>Grossesse/post-partum, seniors, lombalgie, arthrose - protocoles d'adaptation et signaux d'alerte</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M3 - Vente & fidélisation client</h3>
          <p>Transformer un essai en abonnement, gérer les objections, fidélisation, relance client</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M4 - Cues de coaching</h3>
          <p>Maîtrise des instructions tactile, visuel et oral - corriger sans blesser</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M5 - Prévention des blessures</h3>
          <p>Anatomie appliquée, screening client, top 5 blessures running/fitness et protocoles</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M6 - Outils de suivi & data fitness</h3>
          <p>TrueCoach, HRV, tableaux de bord client, communication des données</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M7 - Reformer & Pilates studio</h3>
          <p>Anatomie du Reformer, 10 exercices fondamentaux, standards d'un studio premium</p>
        </div>

        <div className="programme-cqp-cards__module">
          <h3>M8 - Coaching Running · Trail · Sprint</h3>
          <p>VMA, zones d'intensité, plans 5K→Marathon, trail, sprint — lexique complet</p>
        </div>
      </>
    )}

    {activeTab === "date" && (
      <ul className="programme-cqp-cards__dates">
        <li><strong>Début :</strong> Samedi 3 octobre 2026</li>
        <li><strong>Fin présentiel :</strong> Dimanche 6 juin 2027</li>
        <li><strong>Stage pratique :</strong> en semaine en continu (3h/semaine en moyenne sur 35 semaines)</li>
        <li><strong>Examen / jury final :</strong> Samedi 26 juin 2027</li>
        <li><strong>Remise des résultats :</strong> Lundi 26 juillet 2027</li>
      </ul>
    )}

  </div>
</div>

<section className="formation-banner-prog">
  <div className="formation-left">
   
    <h1 className="rejoindre-title">
     INTÉRESSÉ(E) ?
    </h1>
     <p className="rejoindre-subtitle">Admissions ouvertes, places limitées</p>
  </div>

  <div className="formation-right">
       
      <Link to="/inscription" className="formation-btn">
                REJOINDRE LA PROMOTION
              </Link>
  
  </div>
</section>
    



      </div>

      <Footer backgroundColor="black" />
    </>
  );
}